import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Box, Card, Stack, Tooltip, useTheme, Typography } from '@mui/material';

import { useAuth } from 'src/hooks/useAuth';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

import Iconify from 'src/components/iconify';

import { styles } from '../styles';

export default function UserDetails({ departments = [], startDate }) {
  const { t } = useTranslation();
  const { isSmallScreen } = useResponsiveScreen();
  const { user } = useAuth();

  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';

  const resolvedNames = (departments || []).map((dep) => dep.name || dep).filter(Boolean);

  return (
    <Stack spacing={1}>
      <Stack sx={styles.iconBox}>
        <Iconify
          icon="eva:question-mark-circle-outline"
          sx={{
            mr: isSmallScreen ? 0.5 : 1,
            width: isSmallScreen ? 16 : 20,
            height: isSmallScreen ? 16 : 20,
          }}
        />
        <Typography
          variant="h6"
          sx={{
            fontSize: isSmallScreen && '0.8rem',
          }}
        >
          {t('pages.profilePage.userInfo')}
        </Typography>
      </Stack>
      <Card sx={styles.userInfoCard}>
        <Stack spacing={1}>
          <Typography
            sx={{
              fontSize: isSmallScreen && '0.7rem',
            }}
          >
            <b>{t('pages.profilePage.role')}: </b>
            {t(`roles.${user.role}`)}
          </Typography>

          {resolvedNames.length > 0 && (
            <Typography
              sx={{
                fontSize: isSmallScreen && '0.7rem',
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: 0.5,
              }}
            >
              <b>{t('attributes.department')} : </b>
              {resolvedNames.slice(0, 2).join(', ')}
              {resolvedNames.length > 2 && (
                <Tooltip title={resolvedNames.join(', ')} arrow>
                  <Box
                    component="span"
                    sx={{
                      bgcolor: isDark
                        ? 'rgba(255, 255, 255, 0.08)'
                        : 'rgba(145, 158, 171, 0.12)',
                      borderRadius: '4px',
                      px: 0.5,
                      display: 'inline-flex',
                      alignItems: 'center',
                      cursor: 'pointer',
                    }}
                  >
                    <Iconify icon="eva:more-horizontal-fill" width={16} />
                  </Box>
                </Tooltip>
              )}
            </Typography>
          )}

          <Typography
            sx={{
              fontSize: isSmallScreen && '0.7rem',
            }}
          >
            <b>{t('pages.profilePage.startedAt')}: </b>
            {startDate}
          </Typography>
        </Stack>
      </Card>
    </Stack>
  );
}

UserDetails.propTypes = {
  departments: PropTypes.array,
  startDate: PropTypes.string,
};
